export default "__VITE_ASSET__e35f715d__"